import React, {
  FC, useEffect, useState,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import OptionButton from '../components/Button/OptionButton';
import UserReply from '../components/Reply/UserReply';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import RobotLoading from '../components/Loading/RobotLoading';
import { AiTopic } from '../../../../../lib/types/AiTypes';
import Q2 from '../Q2';
import Q3 from '../Q3';
import RobotReply from '../components/Reply/RobotReply';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import InterRegularText from '../../../../../components/Text/InterRegularText';

const Q1: FC<Props> = ({
  addElement,
  cabId,
  setTargetPage,
  setIsToSelectLockerPage,
  deviceCode,
  enterPhoneNumber,
  // 会话ID
  sessionId,
}) => {
  // 选项
  const options: {key: string; zhValue: string; enValue: string; platform: number}[] = [
    { key: 'HungryPanda', zhValue: '熊猫外卖', enValue: 'Hungry Panda', platform: 1 },
    { key: 'Fantuan', zhValue: '饭团外卖', enValue: 'Fantuan', platform: 2 },
    { key: 'Ubereat', zhValue: 'Uber Eats', enValue: 'Uber Eats', platform: 3 },
    { key: 'Menulog', zhValue: 'Menulog', enValue: 'Menulog', platform: 4 },
    { key: 'Doordash', zhValue: 'DoorDash', enValue: 'DoorDash', platform: 5 },
    { key: 'Other', zhValue: '其他送餐平台', enValue: 'Other', platform: 6 },
  ];

  const send = (platform: number) => {
    if (!platform) {
      return;
    }

    if ([1, 2].includes(platform)) {
      addElement(
        <Q2
          h5Platform={platform}
          addElement={addElement}
          cabId={cabId}
          setTargetPage={setTargetPage}
          setIsToSelectLockerPage={setIsToSelectLockerPage}
          deviceCode={deviceCode}
          sessionId={sessionId}
          enterPhoneNumber={enterPhoneNumber}
        />
      );
    }
    else {
      addElement(
        <Q3
          cabId={cabId}
          h5Platform={platform}
          addElement={addElement}
          setTargetPage={setTargetPage}
          deviceCode={deviceCode}
          sessionId={sessionId}
          enterPhoneNumber={enterPhoneNumber}
        />
      );
    }
  };

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '您好，我是 Rita。请问您的外卖是由从以下哪个平台下单?';
    const langEn = 'Great, food delivery! Can you tell me the delivery platform you used?';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.57, getWindowWidth() * 0.7) }}
            langZh={langZh}
            langEn={(
              <InterRegularText>
                Great, food delivery!
                <br />
                Can you tell me the delivery platform you used?
              </InterRegularText>
            )}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, '', 'Q1 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId} speed={15}>
          {
            options.map(({ key, zhValue, enValue, platform }) => {
                return (
                  <RowLeft key={key + '' + (new Date().getTime())}>
                    <OptionButton
                      key={key + (new Date().getTime())}
                      flowId={flowId}
                      langZh={zhValue}
                      langEn={enValue}
                      style={{ width: 110 }}
                      callback={() => {
                        // 用户回复日志
                        addSystemLog(cabId, deviceCode, platform + '', 'Q1 - user: ' + enValue, sessionId);
                        addElement(
                          <UserReply
                            langZh={zhValue}
                            langEn={enValue}
                          />
                        );
                        send(platform);
                      }}
                    />
                  </RowLeft>
                );
            })
          }
        </LeftToRight>
      );
    }, 200);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  addElement: (elements: any) => void;
  cabId: number;
  setTargetPage: (targetPage: string) => void;
  setIsToSelectLockerPage?: (isToLockerPage: boolean) => void;
  deviceCode: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
  // 会话ID
  sessionId: string;
}

export default Q1;
